import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
    const [currentTime, setCurrentTime] = useState(moment().format('dddd, MMMM DD YYYY, h:mm:ss a'));
    const navbarCollapseRef = useRef(null); // Ref for the collapse element
    const navigate = useNavigate();

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(moment().format('dddd, MMMM DD YYYY, h:mm:ss a'));
        }, 1000);

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    // Function to close the navbar collapse
    const closeNavbar = () => {
        if (navbarCollapseRef.current && navbarCollapseRef.current.classList.contains('show')) {
            navbarCollapseRef.current.classList.remove('show'); // Collapse the navbar
        }
    };

    // Function to handle scrolling to the top and navigating
    const handleCategoryClick = (path) => {
        window.scrollTo(0, 0); // Scroll to top
        navigate(path); // Navigate to the path
        closeNavbar(); // Close the navbar after clicking on a link
    };

    return (
        <>
            {/* <!-- Navbar start --> */}
            <div className="container-fluid sticky-top px-0">
                <div className="container-fluid topbar bg-dark1 d-none d-lg-block">
                    <div className="container px-0">
                        <div className="topbar-top d-flex justify-content-between flex-lg-wrap">
                            <div className="top-info flex-grow-0">
                                <div className="pe-2 me-3 border-end border-white d-flex align-items-center">
                                </div>
                                <div className="overflow-hidden" style={{ width: '635px' }}>
                                    <div id="note" className="ps-2">
                                        <img
                                            src="logo.png"
                                            className="img-fluid  border-3 border-primary me-2"
                                            style={{
                                                height: '50px',
                                                width: '130px'
                                            }}
                                            alt=""
                                        />
                                        <a href="#">
                                            <p className="text-black mb-0 link-hover" style={{ color: '#000', font: "400 15px / 21px 'Noto Sans', sans-serif", }}>
                                                Panchayat Khabar Panchayat Khabar Panchayat Khabar .
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="top-link flex-lg-wrap" style={{ color: '#000', font: "400 15px / 21px 'Noto Sans', sans-serif", }} >
                                <i className="fas fa-calendar-alt  border-end border-secondary pe-2 me-2">
                                    {' '}
                                    <span className="" >{currentTime}</span>
                                </i>
                                <div className="d-flex icon">
                                    <p className="mb-0 text-white me-2">Follow Us:</p>
                                    <div>
                                        {/* Social Media Icons */}
                                        <a href="https://www.facebook.com/profile.php?id=100082809802675" className="me-2" target="_blank">
                                            <i style={{ color: '#1877F2' }} className="fab fa-facebook"></i>
                                        </a>
                                        <a href="https://x.com/KhabarPanchayat" className="me-2" target="_blank">
                                            <i style={{ color: 'black' }} className="fas fa-times"></i>
                                        </a>
                                        <a href="https://www.instagram.com/panchayat_khabar/?hl=en" className="me-2" target="_blank">
                                            <i
                                                className="fab fa-instagram"
                                                style={{
                                                    background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    fontSize: '17px',
                                                }}
                                            ></i>
                                        </a>
                                        <a href="https://www.youtube.com/@PANCHAYAT_KHABAR" className="me-2" target="_blank">
                                            <i className="fab fa-youtube " style={{ color: 'red' }}></i>
                                        </a>
                                        <a href="https://wa.me/9792531351" className="me-2" target="_blank" rel="noopener noreferrer">
                                            <i style={{ color: 'white' }} className="fab fa-whatsapp text-success link-hover"></i>
                                        </a>

                                        <a href="https://wa.me/9792531351" className="whatshap" target="_blank" rel="noopener noreferrer">
                                            <i style={{ fontSize: '50px' }} className="fab fa-whatsapp text-success link-hover"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid bg-dark" >
                    <div className="container ">
                        <nav className="navbar navbar-light navbar-expand-xl ">
                            <a href="" className="nav-img">
                                <img src="logo.png"
                                    style={{
                                        height: '50px',
                                        width: '130px'
                                    }} alt="" />
                            </a>
                            <button
                                className="navbar-toggler "
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#navbarCollapse"
                            >
                                <span className="fa fa-bars text-primary"></span>
                            </button>
                            <div
                                className="collapse navbar-collapse   "
                                id="navbarCollapse"
                                ref={navbarCollapseRef}
                            >
                                <p className="mb-0 text-white fs-6 fw-normal" style={{ height: '50px', display: 'flex', alignItems: 'center' }}>
                                    <img
                                        src="logo.png"
                                        className="zoom-logo"
                                        style={{
                                            height: '100%',
                                            width: 'auto',
                                            height: '100px',
                                            marginRight: '20px',
                                            marginTop: '15px'
                                        }}
                                        alt="Logo"
                                    />
                                </p>
                                <div className="navbar-nav mx-auto border-top">
                                    <Link to="/" className="nav-item nav-link" onClick={() => handleCategoryClick("/")}>होम</Link>
                                    <Link to="/Editoal" className="nav-item nav-link" onClick={() => handleCategoryClick("/Editoal")}>सम्पादकीय</Link>
                                    <Link to="/Khel" className="nav-item nav-link" onClick={() => handleCategoryClick("/Khel")}>खेल जगत</Link>
                                    <Link to="/Study" className="nav-item nav-link" onClick={() => handleCategoryClick("/Study")}>शिक्षा</Link>
                                    <Link to="/Health" className="nav-item nav-link" onClick={() => handleCategoryClick("/Health")}>स्वास्थ्य</Link>
                                    <Link to="/Bussiness" className="nav-item nav-link" onClick={() => handleCategoryClick("/Bussiness")}>कारोबार</Link>
                                    <Link to="/District" className="nav-item nav-link" onClick={() => handleCategoryClick("/District")}>जनपदीय</Link>
                                    <Link to="/Awaranktha" className="nav-item nav-link" onClick={() => handleCategoryClick("/Awaranktha")}>आवरण कथा</Link>
                                    <Link to="/Desh" className="nav-item nav-link" onClick={() => handleCategoryClick("/Desh")}>देश</Link>

                                    <div className="nav-item dropdown" style={{ backgroundColor: '#0078D4 ', color: 'white' }}>
                                        <Link
                                            to="#"
                                            className="nav-link dropdown-toggle"
                                            role="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            पंचायत
                                        </Link>
                                        <div className="dropdown-menu rounded-0 m-0" style={{ backgroundColor: '#0078D4', color: '#0078D4' }}>
                                            <Link to="/Lokshbha" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Lokshbha")}>लोकसभा पंचायत</Link>
                                            <Link to="/Vidhanshbha" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Vidhanshbha")}>विधानसभा पंचायत</Link>
                                            <Link to='/Grampanchayat' style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick('/Grampanchayat')}>ग्राम पंचायत</Link>
                                        </div>
                                    </div>

                                    <div className="nav-item dropdown">
                                        <Link
                                            to="#"
                                            className="nav-link dropdown-toggle"
                                            role="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            अन्य
                                        </Link>
                                        <div className="dropdown-menu rounded-0 m-0">
                                            <Link to="/Filmi" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Filmi")}>फ़िल्मी-सितारे</Link>
                                            <Link to="/Lagukatha" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Lagukatha")}>लघुकथा</Link>
                                            <Link to="/Astrology" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Astrology")}>ज्योतिषी</Link>
                                            <Link to="/Krishi" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Krishi")}>कृषि-पंचांग</Link>
                                            <Link to="/Beuty" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Beuty")}>ब्यूटी-व-फैशन</Link>
                                            <Link to="/Khabar" style={{ backgroundColor: '#0078D4 ', color: 'white' }} className="dropdown-item" onClick={() => handleCategoryClick("/Khabar")}>खोज-ख़बर</Link>
                                        </div>
                                    </div>

                                    <Link to="/contact" className="nav-item nav-link" onClick={() => handleCategoryClick("/contact")}>संपर्क करे</Link>
                                </div>

                            </div>
                        </nav>
                    </div>
                </div>
            </div>
            {/* <!-- Navbar End --> */}
        </>
    );
};

export default Navbar;
